// extracted by mini-css-extract-plugin
module.exports = {"m--copy-stat":"CopyStat_m--copy-stat__ABruE"};